import './App.css';
import React from 'react';
import { AppContextProvider } from './context/AppContext';
import { RouterProvider } from 'react-router-dom';
import router from './Router';





const App = React.memo(() => { {

  return (
      <AppContextProvider>
        <div className='App' style={{backgroundColor: "#ebedee", display: "flex", flexDirection: "column"}}>
          <RouterProvider router={router}/>
        </div>
      </AppContextProvider>
  );
}})

export default App;
